import * as React from 'react';

export class About extends React.Component {
  public render() {
    return <div>About</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/about.tsx